const HeroFormStepDesc = () => {
  const step = document.querySelector(".hero-form__step:last-of-type .description");

  if (step) {
    const words = step.textContent.split(' '); 
    if (words.length > 2) {
      step.textContent = words.slice(0, 2).join(' ');
    }
  }
}

export default HeroFormStepDesc;
